import React, { useState } from 'react';
import PropTypes from 'prop-types';

import BasePageUAM from '../BasePageUAM/BasePageUAM';
import RegistrationEmailPanel from './Panels/RegistrationEmailPanel/RegistrationEmailPanel';
import EmailPendingPanel from '../../shared-panels/uam/EmailPendingPanel/EmailPendingPanel';
import { makeInitialField } from '../../utils/field-utils';
import AlreadyRegisteredPanel from './Panels/AlreadyRegisteredPanel/AlreadyRegisteredPanel';

const RegistrationEmailPage = ({ brand, destPath }) => {
  const [emailPending, setEmailPending] = useState(false);
  const [registrationComplete, setRegistrationComplete] = useState(false);

  const [email, setEmail] = useState(makeInitialField(''));

  const getPanel = () => {
    if (emailPending) {
      return <EmailPendingPanel email={email.value} />;
    }

    if (registrationComplete) {
      return <AlreadyRegisteredPanel email={email.value} />;
    }

    return (
      <RegistrationEmailPanel
        destPath={destPath}
        setEmailPending={setEmailPending}
        email={email}
        setEmail={setEmail}
        setRegistrationComplete={setRegistrationComplete}
      />
    );
  };

  return (
    <BasePageUAM activeTab={2} brand={brand} destPath={destPath} needsDestPath showTabs={!emailPending}>
      {
        getPanel()
      }
    </BasePageUAM>
  );
};

RegistrationEmailPage.propTypes = {
  brand: PropTypes.object.isRequired,
  destPath: PropTypes.object.isRequired,
};

export default RegistrationEmailPage;
